import {loadHtmlScript} from "../utils/loadHtmlScript";

export const loadCloudflarePixel = () => {
    loadHtmlScript('https://static.cloudflareinsights.com/beacon.min.js', {
        options: {
            "data-cf-beacon": '{"token": "8daa88090ef845c782233272b7065935"}'
        }
    })
}